/**
 * Yönetim paneli oturumu — sessionStorage (sekme kapanınca silinir).
 */

const STORAGE_KEY = 'ga_admin_session'

/**
 * @returns {null | { token: string, username?: string }}
 */
export function getAdminSession() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed.token !== 'string' || !parsed.token) return null
    return parsed
  } catch {
    return null
  }
}

/** @param {{ token: string, username?: string }} payload */
export function setAdminSession(payload) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
}

export function clearAdminSession() {
  sessionStorage.removeItem(STORAGE_KEY)
}
